// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"logo-github"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M8.50772 23C8.50772 22.8405 8.50574 22.6061 8.50311 22.2389C8.49789 21.5081 8.49009 20.4149 8.49009 19.1577C8.49009 17.8337 8.93142 16.9864 9.44334 16.5451C6.3011 16.1921 3 14.9917 3 9.57219C3 8.01876 3.54726 6.76529 4.44754 5.7768C4.3063 5.42374 3.81205 3.97616 4.58877 2.03433C4.58877 2.03433 5.77151 1.64593 8.47242 3.48191C9.6003 3.16471 10.8016 3.00052 12 3C13.1984 3.00052 14.3997 3.16471 15.5276 3.48191C18.2285 1.64593 19.4112 2.03433 19.4112 2.03433C20.1879 3.97616 19.6937 5.42374 19.5525 5.7768C20.4527 6.76529 21 8.01876 21 9.57219C21 14.9917 17.6989 16.1921 14.5567 16.5451C15.0686 16.9864 15.5099 17.8337 15.5099 19.1577C15.5099 20.4149 15.5021 21.5081 15.4969 22.2389C15.4943 22.6061 15.4923 22.8405 15.4923 23M2.5 17.5L2.7142 17.6071C3.2319 17.8659 3.68725 18.2341 4.04882 18.686L4.59927 19.3741C5.16858 20.0857 6.03052 20.5 6.94187 20.5H8.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-logo-github')
export default class LogoGithubIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-github',
    }
  }
}
